// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Vue2Touch from 'vue2-touch'
import VueCollapse from 'vue2-collapse'
import SmoothScroll from 'vue-smoothscroll'
import VueI18n from 'vue-i18n'
import messages from './i18n/str'
import { VueHammer } from 'vue2-hammer'
import VueGAPI from 'vue-gapi'
import SocialSharing from 'vue-social-sharing'
import VueAnalytics from 'vue-analytics'

import '@/style/animations.css'

Vue.use(VueHammer)
Vue.use(SmoothScroll)
Vue.use(Vue2Touch)
Vue.use(VueCollapse)
Vue.use(SocialSharing)

VueHammer.config.swipe = {
  direction: 6
}

Vue.config.productionTip = false

Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'ar',
  messages
})

Vue.use(VueAnalytics, {
  id: 'UA-137195980-1',
  beforeFirstHit () {
    Vue.$ga.set('anonymizeIp', true)
  },
  router
})

// create the 'options' object
const apiConfig = {
  apiKey: "AIzaSyB_7Cxi_tfl0s1ykXHMOjY7inqpB_53pTQ",
  clientId: "813349387752-uvn1qf24vd947b9vmam09e0ecjn80ekd.apps.googleusercontent.com",
  discoveryDocs: ["https://sheets.googleapis.com/$discovery/rest?version=v4"],
  scope: "https://www.googleapis.com/auth/spreadsheets"
}
 
// Use the plugin and pass along the configuration
Vue.use(VueGAPI, apiConfig);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js